import React from 'react';
import lodashCompact from 'lodash/fp/compact';

import { DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUP_INDEX } from 'common/dataTableConstants';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrLink from 'client/components/SrLink/SrLink';
import SrDataTableUI from 'client/components/SrDataTableUI';
import { SR_TABLE_THEME_PARTNER_CLEAR } from 'client/components/SrTable';
import SrDataTableConnected from 'client/components/SrDataTableConnected';

const UPDataTableListingScraperLogGroupIndex = () => {
  const dataTableHeaders = [
    { content: 'ID' },
    { content: 'Created Date' },
    { content: 'Scraped Count' },
    { content: '' },
  ];

  return (
    <SrDataTableConnected
      dataSource={DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUP_INDEX}
      rootViewId={DATA_TABLE_SOURCE_LISTINGS_SCRAPER_LOG_GROUP_INDEX}
      initialViewSettings={{
        sort: {
          createdAt: 'desc',
        },
      }}
      count={8}
      itemsPropName="logGroupIndex"
      resetOnUnmount
    >
      {({
        logGroupIndex,
        viewSettings,
        dataTableApiState,
        loadNextPage,
        dataTableIsFullyLoaded,
      }) => {
        const logGroupIndexRows = logGroupIndex.map((logGroup) => {
          return {
            cells: [
              { content: logGroup.id },
              { content: momentWithAustinTimezone(logGroup.createdAt).format('MM/DD/YYYY h:mm A') },
              { content: logGroup.scrapedCount },
              {
                content: (
                  <>
                    <SrLink to={`/utility-profit/admin/scraper-logs?logGroupId=${logGroup.id}`}>
                      <SrText
                        font="greycliff"
                        size="16"
                        weight="700"
                        lineHeight="50px"
                        color="blue300"
                      >
                        View Logs
                      </SrText>
                    </SrLink>
                  </>
                ),
              },
            ],
          };
        });

        const loadMoreRow = dataTableIsFullyLoaded
          ? null
          : {
              onClick: () => (dataTableApiState.inProgress ? null : loadNextPage()),
              cells: [
                {
                  content: (
                    <div
                      style={{ height: '100%', textAlign: 'center', backgroundColor: '#F5F9FF' }}
                    >
                      <SrText
                        lineHeight="50px"
                        font="greycliff"
                        weight="800"
                        size="16"
                        color="blue300"
                      >
                        Load more logs
                      </SrText>
                    </div>
                  ),
                  colSpan: dataTableHeaders.length,
                  noPadding: true,
                },
              ],
            };

        return (
          <SrBox>
            <SrBox marginTop="20px">
              <SrDataTableUI
                sticky
                theme={SR_TABLE_THEME_PARTNER_CLEAR}
                dataTableViewSettings={viewSettings}
                headers={dataTableHeaders}
                minWidth="100%"
                rows={lodashCompact([...logGroupIndexRows, loadMoreRow])}
              />
              {dataTableApiState.inProgress && (
                <div>
                  <div className="loading-ellipses clearfix" />
                </div>
              )}
            </SrBox>
            {logGroupIndex.length === 0 && dataTableIsFullyLoaded && (
              <SrBox backgroundColor="white" display="flex" justifyContent="center" padding="20px">
                <SrText font="greycliff" weight="500" fontSize="16px" fontStyle="italic">
                  No scraper logs created yet.
                </SrText>
              </SrBox>
            )}
          </SrBox>
        );
      }}
    </SrDataTableConnected>
  );
};

UPDataTableListingScraperLogGroupIndex.displayName = 'UPDataTableListingScraperLogGroupIndex';

export default UPDataTableListingScraperLogGroupIndex;
